import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import SaveAsNewSearchButton from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/components/SaveAsNewSearchButton";
import SaveSearchButton from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/components/SavedSearchButton/SavedSearchButton";
import UpdateSearchButton from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/components/UpdateSearchButton";

import { LINE_HEIGHT, smButtonStyle } from "../../components/message-strategy/styles";

export const StyledUpdateSearchButton = styled(UpdateSearchButton)`
    ${smButtonStyle};
`;

export const StyledSaveAsNewSearchButton = styled(SaveAsNewSearchButton)`
    ${smButtonStyle};
`;

export const StyledSavedSearchButton = styled(SaveSearchButton).attrs({
    iconSize: LINE_HEIGHT,
})`
    ${smButtonStyle};

    ${SWReactIcons} {
        margin-right: 3px;
    }
`;
